import { render } from "./Shark.vue?vue&type=template&id=65ce628c"
import script from "./Shark.vue?vue&type=script&lang=js"
export * from "./Shark.vue?vue&type=script&lang=js"

import "./Shark.vue?vue&type=style&index=0&id=65ce628c&lang=css"
script.render = render

export default script